import React from "react";
import * as FileSaver from "file-saver";
import * as ExcelJs from "exceljs";
import "./DownLoadXLSX.scss"

import UniversalButton from "components/uiComponents/UniversalButton";

import { ReactComponent as ReportIcon } from "static/icons/report-download.svg";

const DownLoadXLSX = ({ header, fileName, table }) => {
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = () => {
    // Create workbook and sheet
    const workbook = new ExcelJs.Workbook();

    const worksheet = workbook.addWorksheet("My Sheet");


    const createHeaders = (headersArray) => {
      return headersArray.map(( headerText ) => {
         return {header: headerText, key: headerText, width: 30}
      })
    }

    const tableHeader =  createHeaders(table.header);


    const createContent = (rowsArray) => {
      const data = rowsArray.map(( Row ) => {
        return  {
            [tableHeader[0].key]: Row[0],
            [tableHeader[1].key]: Row[1],
            [tableHeader[2].key]: Row[2],
            [tableHeader[3].key]: Row[3],
            [tableHeader[4].key]: Row[4],
            [tableHeader[5].key]: Row[5],
            [tableHeader[6].key]: Row[6],
            [tableHeader[7].key]: Row[7],
          }
      })
      return data
    }
    const tableContent = createContent(table.content)



    worksheet.columns = [{header: '', key: 'total', width: 30},...tableHeader];

    createContent(table.content);

    tableContent.map(( RowData ) => {
      worksheet.addRow(RowData)
    })
    worksheet.addRow({total: 'total', [tableHeader[0].key]: table.content.length});

    const colorFillHeader = "F3F6F8";
    const colorFillTotals = "FF95B3D7";
    const commonPatternFill = "solid";
    const colorBorder = "FF181818";
    const colorMissing = "FF3D00";
    const borderStyle = "thin";
    const alignmentCenter = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };

    const borderThinBlack = {
      top: {style: borderStyle, color: {argb: colorBorder}},
      right: {style: borderStyle, color: {argb: colorBorder}},
      bottom: {style: borderStyle, color: {argb: colorBorder}},
      left: {style: borderStyle, color: {argb: colorBorder}},
    };

    const headerRowIndex = 1;
    const totalsRowIndex = worksheet.rowCount;

    for (let rowIndex = 1; rowIndex <= worksheet.rowCount; rowIndex++) {
      for (
        let columnIndex = 1;
        columnIndex <= worksheet.columnCount;
        columnIndex++
      ) {
        const cell = worksheet.getCell(rowIndex, columnIndex);
        cell.alignment = alignmentCenter;
        cell.border = borderThinBlack;

        if (rowIndex === headerRowIndex) {
          cell.font = {
            bold: true,
            size: 14,
          };

          cell.fill = {
            type: "pattern",
            pattern: commonPatternFill,
            fgColor: {argb: colorFillHeader},
          };
        } else if (rowIndex === totalsRowIndex) {
          cell.fill = {
            type: "pattern",
            pattern: commonPatternFill,
            fgColor: {argb: colorFillTotals},
          };
        } else {
          // Other rows except the header
          cell.font = {
            size: 12,
          };
        }

        if (String(cell["_value"]["model"]["value"]).includes("missing")) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {argb: colorMissing},
          };
        }
      }
    }

    //Autosize column width
    autosizeColumnsWidth(worksheet);

    // Conditional formatting dependent on value in first column
    addConditionalFormatting(worksheet);

    workbook.xlsx.writeBuffer().then(function (buffer) {
      const blob = new Blob([buffer], {type: fileType});
      // save excel file
      FileSaver.saveAs(blob, fileName + fileExtension);
    });
  };

  return (
    <UniversalButton
      label={"Download report"}
      leftIcon={<ReportIcon className="download-excel__button_icon" />}
      size="md"
      isRounded="sm"
      labelColor="white"
      labelHoverColor="white"
      backgroundColor="blue-dark"
      backgroundHoverColor="blue-light"
      onClick={exportToCSV}
    />
  );
};



function addConditionalFormatting(sheet) {
  const cellRefStart = "A2";
  const cellRefEnd = sheet.getCell(
    sheet.rowCount - 1,
    sheet.columnCount
  ).address;

  const ref = cellRefStart + ":" + cellRefEnd;
  sheet.addConditionalFormatting({
    ref: ref,
    rules: [
      {
        type: "expression",
        formulae: ["=EXACT($A2, TRUE)"],
        style: {
          fill: {
            type: "pattern",
            pattern: "solid",
            bgColor: { argb: "FFEBF1DE" },
          },
        },
      },
    ],
  });
}

function autosizeColumnsWidth(sheet) {
  sheet.columns.forEach((column) => {
    const lengths = column.values.map((value) => value.toString().length);
    if(column.width){
      column.width = Math.max(
        Math.max(...lengths.filter((value) => typeof value === "number")) + 2,
        column.header.length + 6
      )
    };
  });
}


export default DownLoadXLSX
